// Sentry init — main.tsx'te app boot'tan önce çağırılır.
// VITE_SENTRY_DSN yoksa devre dışı (development'ta default).
import * as Sentry from '@sentry/react'

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
  if (!dsn) {
    // Development veya missing config — sessizce geç
    return
  }
  Sentry.init({
    dsn,
    environment: (import.meta.env.VITE_SENTRY_ENV as string) || 'production',
    release: (import.meta.env.VITE_SENTRY_RELEASE as string) || undefined,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false, // Yayıncı dashboard'u, hassas data yok; replay net olsun
        blockAllMedia: false,
      }),
    ],
    // Tracing — düşük trafik (2-3 kullanıcı), full visibility için %100.
    // Trafik artarsa 0.3-0.5'e indirilir.
    tracesSampleRate: 1.0,
    // Session Replay — sadece hata olunca kaydet, otomatik kaydetme yok
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    // PII
    sendDefaultPii: false,
    // Browser console error/warning'leri Sentry'ye düşme — gürültü çoğunlukla
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
    ],
  })
}

export { Sentry }
